import * as React from 'react';

const FastShipperBadge72 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 72 72", width: 72, height: 72, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M72 36c0 19.881-16.117 36-36 36C16.119 72 0 55.881 0 36 0 16.117 16.119 0 36 0c19.883 0 36 16.117 36 36"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M14.366 19.267c-.939 0-1.832.75-1.995 1.674-.163.925.466 1.674 1.405 1.674h34.163c2.88 0 5.33 1.398 6.547 3.736l3.197 6.136c.761 1.461.992 3.197.659 4.97l-1.496 7.969c-.265 1.412-1.633 2.548-3.066 2.548h-1.078q-.159 0-.315.028a6.622 6.622 0 0 0-12.545-.028h-6.66a6.622 6.622 0 0 0-12.536 0h-.797c-1.458 0-2.428-1.173-2.157-2.609l1.856-9.826c.174-.924-.444-1.683-1.38-1.694-.937-.012-1.838.729-2.013 1.653L14.3 45.324c-.623 3.3 1.607 5.998 4.959 5.998h1.147a6.621 6.621 0 0 0 13.015 0h6.182a6.621 6.621 0 0 0 13.014 0h.572c3.297 0 6.44-2.612 7.05-5.859l1.496-7.968c.462-2.462.143-4.874-.915-6.904l-3.197-6.135c-1.692-3.248-5.093-5.189-9.094-5.189zm15.767 30.84a3.219 3.219 0 1 1-6.438 0 3.219 3.219 0 0 1 6.438 0m15.977 3.218a3.219 3.219 0 1 1 0-6.437 3.219 3.219 0 0 1 0 6.438Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M15.71 26.348c-.939 0-1.832.75-1.995 1.674-.163.925.466 1.674 1.405 1.674h10.756c.939 0 1.832-.75 1.995-1.674s-.466-1.674-1.404-1.674zm30.038 2.083-.95 5.39c-.2 1.136.572 2.056 1.725 2.056h5.012c1.7 0 3.022-1.894 2.271-3.255l-2.736-4.96c-.446-.808-1.309-1.287-2.319-1.287H48.2c-1.154 0-2.251.92-2.451 2.056Z"
  }
));
FastShipperBadge72.Size = 72;
FastShipperBadge72.Title = "FastShipperBadge";

export { FastShipperBadge72 as default };
